import { render, staticRenderFns } from "./CanvasSettingsWorkflow.vue?vue&type=template&id=61798b6d"
import script from "./CanvasSettingsWorkflow.vue?vue&type=script&lang=ts"
export * from "./CanvasSettingsWorkflow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@7.1.2_@rspack+core@2.1.8_webpack_6b8fc1273ff717b8f145294df5db1f84/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports